import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class LineWorkAPIs extends EarthBrainViewerAPIs {
    async generateLineWorksCrossSection(lineID, setting) {
        await this._scDesign.generateLineWorkCrossSection(lineID, setting);
    }
    disposeLineWorksCrossSection(lineID) {
        this._scDesign.disposeLineWorksCrossSection(lineID);
    }
    getCrossSectionDataOfLineWorks(lineId) {
        return this._scDesign.getCrossSectionDataOfLineWorks(lineId);
    }
    get2DCrossSectionDataOfLineWorks(lineId) {
        return this._scDesign.get2DCrossSectionDataOfLineWorks(lineId);
    }
    fetchLineWorkJSON(lineID) {
        return this._scDesign.fetchLineWorkJSON(lineID);
    }
    async generateAlignmentCrossSection(alignmentID, setting) {
        await this._scDesign.generateAlignmentCrossSection(alignmentID, setting);
    }
    async generateCrossSectionForSima(simaID, setting) {
        await this._scDesign.generateCrossSectionForSima(simaID, setting);
    }
    async updateAlignmentStationInterval(alignmentID, stationInterval) {
        await this._scDesign.updateAlignmentStationInterval(alignmentID, stationInterval);
    }
}
//# sourceMappingURL=lineworks.js.map